module.exports = require("./file");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file2/index.js
 ** module id = 6
 ** module chunks = 0
 **/